var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8247E5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.092 12.693c-.369-.215-.848-.215-1.254 0l-2.879 1.654-1.955 1.078-2.879 1.653c-.369.216-.848.216-1.254 0l-2.288-1.294c-.369-.215-.627-.61-.627-1.042V12.19c0-.431.258-.826.627-1.042l2.25-1.258c.37-.216.85-.216 1.255 0l2.25 1.258c.37.216.628.611.628 1.042v1.654l1.955-1.115v-1.653c0-.432-.259-.827-.628-1.043l-4.166-2.372c-.37-.215-.849-.215-1.255 0L6.374 9.953c-.407.215-.665.61-.665 1.042v4.78c0 .431.258.826.627 1.042l4.204 2.372c.37.216.85.216 1.255 0l2.879-1.617 1.955-1.115 2.879-1.617c.369-.215.848-.215 1.254 0l2.25 1.258c.37.215.628.61.628 1.042v2.408c0 .431-.259.826-.627 1.042l-2.25 1.294c-.37.216-.85.216-1.255 0l-2.25-1.258c-.37-.215-.628-.61-.628-1.042v-1.654l-1.955 1.115v1.654c0 .43.259.826.628 1.042l4.204 2.372c.37.215.848.215 1.254 0l4.204-2.372c.37-.216.628-.611.628-1.042v-4.78c0-.432-.259-.827-.628-1.043l-4.204-2.335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.5e7f7e37b8bf55b2e23f8c4ddfa232ea.svg";
export { ForwardRef as ReactComponent };